// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../node_modules/codemirror/lib/codemirror.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../node_modules/codemirror/theme/material.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== AGGRESSIVE INPUT FIELD WIDTH ENFORCEMENT ===== */
/* Force ALL input fields to be full width regardless of container */
input,
select,
textarea,
.input-field,
.nextui-input,
.nextui-textarea,
.nextui-select-trigger,
.nextui-select-wrapper,
.nextui-input-wrapper,
[data-slot="input"],
[data-slot="textarea"],
[data-slot="select"] {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
}

/* Force input containers to expand fully */
.nextui-input-wrapper,
.nextui-textarea-wrapper,
.nextui-select-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

/* Override any flex constraints that might limit width */
.nextui-input-wrapper > div,
.nextui-input-wrapper > span,
.nextui-textarea-wrapper > div,
.nextui-textarea-wrapper > span,
.nextui-select-wrapper > div,
.nextui-select-wrapper > span {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

/* Force internal input elements to expand */
.nextui-input-wrapper input,
.nextui-input-wrapper textarea,
.nextui-textarea-wrapper textarea,
.nextui-select-wrapper select {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

/* Target the exact structure from the screenshot */
.space-y-6 input,
.space-y-6 .nextui-input-wrapper,
.space-y-6 .nextui-input-wrapper > * {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

/* ===== FORCE NEXTUI FULL WIDTH ===== */
/* Target NextUI components with maximum specificity and force full width */
.nextui-input-wrapper,
.nextui-input-wrapper[class*="inputWrapper"],
.nextui-input-wrapper[class*="wrapper"],
.nextui-input-wrapper[class*="base"],
.nextui-input-wrapper[class*="input"],
.nextui-input-wrapper[class*="field"],
.nextui-input-wrapper.bg-white,
.nextui-input-wrapper.border-gray-300,
.nextui-input-wrapper.h-10,
.nextui-input-wrapper.w-full,
.nextui-input-wrapper.max-w-full {
  width: 100% !important !important;
  max-width: 100% !important !important;
  min-width: 0 !important !important;
  flex: 1 1 !important !important;
  display: flex !important !important;
  align-items: center !important !important;
}

/* Force all child elements to expand */
.nextui-input-wrapper > *,
.nextui-input-wrapper > div,
.nextui-input-wrapper > span,
.nextui-input-wrapper > input,
.nextui-input-wrapper > textarea,
.nextui-input-wrapper > select,
.nextui-input-wrapper > button,
.nextui-input-wrapper > label {
  width: 100% !important !important;
  max-width: 100% !important !important;
  min-width: 0 !important !important;
  flex: 1 1 !important !important;
}

/* Override any Tailwind width classes */
.nextui-input-wrapper[class*="w-"],
.nextui-input-wrapper[class*="max-w-"],
.nextui-input-wrapper[class*="min-w-"] {
  width: 100% !important !important;
  max-width: 100% !important !important;
  min-width: 0 !important !important;
}

/* Remove redundant information displays */

/* ===== POPUP IMPROVEMENTS ===== */
/* Remove redundant information displays */
.modal .info-banner,
.popup .info-banner,
[role="dialog"] .info-banner {
  /* Hide redundant total count banners */
  display: none !important;
}

/* Optimize search bar styling */
.modal .search-input,
.popup .search-input,
[role="dialog"] .search-input {
  border: 2px solid #d4d4d4 !important;
  border-radius: 0.5rem !important;
  padding: 0.75rem 1rem !important;
  font-size: 0.875rem !important;
  transition: all 0.2s ease !important;
}

.modal .search-input:focus,
.popup .search-input:focus,
[role="dialog"] .search-input:focus {
  border-color: #10b981 !important;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
  outline: none !important;
}

/* Optimize item list styling */
.modal .item-list,
.popup .item-list,
[role="dialog"] .item-list {
  max-height: 60vh !important;
  overflow-y: auto !important;
  padding: 0.5rem 0 !important;
}

/* Remove duplicate pagination information */
.modal .pagination-info,
.popup .pagination-info,
[role="dialog"] .pagination-info {
  /* Keep only essential pagination info */
  font-size: 0.875rem !important;
  color: #6b7280 !important;
}

/* Hide redundant total count at bottom */
.modal .total-count-bottom,
.popup .total-count-bottom,
[role="dialog"] .total-count-bottom {
  display: none !important;
}

/* Optimize navigation buttons */
.modal .nav-buttons,
.popup .nav-buttons,
[role="dialog"] .nav-buttons {
  display: flex !important;
  gap: 0.5rem !important;
  align-items: center !important;
}

.modal .nav-button,
.popup .nav-button,
[role="dialog"] .nav-button {
  padding: 0.5rem 1rem !important;
  border-radius: 0.375rem !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.modal .nav-button:disabled,
.popup .nav-button:disabled,
[role="dialog"] .nav-button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Ensure single close button */
.modal .close-button,
.popup .close-button,
[role="dialog"] .close-button {
  /* Remove duplicate close buttons */
  position: absolute !important;
  top: 1rem !important;
  right: 1rem !important;
  z-index: 10 !important;
}

/* Hide any additional close elements */
.modal .close-element:not(:first-child),
.popup .close-element:not(:first-child),
[role="dialog"] .close-element:not(:first-child) {
  display: none !important;
}

/* Optimize modal header */
.modal .modal-header,
.popup .modal-header,
[role="dialog"] .modal-header {
  padding: 1.5rem 1.5rem 1rem 1.5rem !important;
  border-bottom: 1px solid #e5e7eb !important;
  background: #f9fafb !important;
  border-radius: 0.75rem 0.75rem 0 0 !important;
}

/* Optimize modal body */
.modal .modal-body,
.popup .modal-body,
[role="dialog"] .modal-body {
  padding: 1.5rem !important;
  max-height: 70vh !important;
  overflow-y: auto !important;
}

/* Optimize modal footer */
.modal .modal-footer,
.popup .modal-footer,
[role="dialog"] .modal-footer {
  padding: 1rem 1.5rem 1.5rem 1.5rem !important;
  border-top: 1px solid #e5e7eb !important;
  background: #f9fafb !important;
  border-radius: 0 0 0.75rem 0.75rem !important;
}

/* Remove redundant text displays */
.modal .redundant-text,
.popup .redundant-text,
[role="dialog"] .redundant-text {
  display: none !important;
}

/* Optimize item display */
.modal .item,
.popup .item,
[role="dialog"] .item {
  padding: 0.75rem !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 0.375rem !important;
  margin-bottom: 0.5rem !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
}

.modal .item:hover,
.popup .item:hover,
[role="dialog"] .item:hover {
  border-color: #10b981 !important;
  background: #f0fdf4 !important;
  transform: translateY(-1px) !important;
}

/* Ensure consistent button styling */
.modal button,
.popup button,
[role="dialog"] button {
  border-radius: 0.375rem !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.modal button:not(:disabled):hover,
.popup button:not(:disabled):hover,
[role="dialog"] button:not(:disabled):hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

/* ===== EXISTING STYLES - DO NOT MODIFY ===== */
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.dark-textfield {
  background-color: #000; /* Black background color */
  color: #fff; /* White text color */
  border: 1px solid #666; /* Border color */
  padding: 8px; /* Padding around the text field */
  border-radius: 4px; /* Border radius for rounded corners */
  width: 300px; /* Adjust width as needed */
  outline: none; /* Remove outline on focus */
}

.react-codemirror2 > .CodeMirror:first-child { display: none; }

.string { color: green; }
.number { color: darkorange; }
.boolean { color: blue; }
.null { color: magenta; }
.key { color: red; }

.custom-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  max-width: 300px;
  &::-webkit-scrollbar {
    display: none;
  }
  /* scrollbar-width: thin; */
}

.hide-scrollbar{
  &::-webkit-scrollbar {
    display: none;
  }
}

.custom-scrollbar{
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
    z-index: 1000;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
    z-index: 1000;
    border: 1px solid #e2e8f0;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

/* Enhanced scrollbar for sidebar navigation */

/* Modal improvements for better scrolling and display */
.modal-content-scrollable {
  max-height: 90vh;
  overflow-y: auto;
}

.modal-body-scrollable {
  max-height: calc(90vh - 120px);
  overflow-y: auto;
  padding: 1.5rem;
}

/* Custom scrollbar for modal content */
.modal-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f7fafc;
}

.modal-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.modal-scrollbar::-webkit-scrollbar-track {
  background: #f7fafc;
  border-radius: 4px;
}

.modal-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.modal-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.sidebar-scrollbar {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
    border: 1px solid #f3f4f6;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

/* Hide scrollbar for main content area */
.main-content-scroll {
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* .bg-overlay\\/50 {
  background-color: transparent;
} */
 
body > iframe {
  display: none;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #a0aec0;
  border-radius: 4px;
  border: 2px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #718096;
}

::-webkit-scrollbar-thumb:active {
  background-color: #4a5568;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.skeleton-chip {
  background: linear-gradient(
    90deg,
    rgba(238, 238, 238, 0.3) 25%,
    rgba(243, 241, 241, 0.846) 50%,
    rgba(238, 238, 238, 0.3) 75%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite ease-in-out;
}

/* ===== UNIFIED DESIGN SYSTEM - NEW ADDITIONS ===== */

/* CSS Custom Properties for consistent colors */
:root {
  /* Primary Colors - Emerald Theme */
  --color-primary-50: #ecfdf5;
  --color-primary-100: #d1fae5;
  --color-primary-200: #a7f3d0;
  --color-primary-300: #6ee7b7;
  --color-primary-400: #34d399;
  --color-primary-500: #10b981;
  --color-primary-600: #059669;
  --color-primary-700: #047857;
  --color-primary-800: #065f46;
  --color-primary-900: #064e3b;
  
  /* Neutral Colors - Consistent across app */
  --color-neutral-50: #fafafa;
  --color-neutral-100: #f5f5f5;
  --color-neutral-200: #e5e5e5;
  --color-neutral-300: #d4d4d4;
  --color-neutral-400: #a3a3a3;
  --color-neutral-500: #737373;
  --color-neutral-600: #525252;
  --color-neutral-700: #404040;
  --color-neutral-800: #262626;
  --color-neutral-900: #171717;
  
  /* Semantic Colors */
  --color-success: #10b981;
  --color-success-light: #d1fae5;
  --color-success-dark: #047857;
  --color-error: #ef4444;
  --color-error-light: #fee2e2;
  --color-error-dark: #dc2626;
  --color-warning: #f59e0b;
  --color-warning-light: #fef3c7;
  --color-warning-dark: #d97706;
  --color-info: #3b82f6;
  --color-info-light: #dbeafe;
  --color-info-dark: #2563eb;
  
  /* Spacing Scale */
  --spacing-xs: 0.25rem;   /* 4px */
  --spacing-sm: 0.5rem;    /* 8px */
  --spacing-md: 0.75rem;   /* 12px */
  --spacing-lg: 1rem;      /* 16px */
  --spacing-xl: 1.5rem;    /* 24px */
  --spacing-2xl: 2rem;     /* 32px */
  --spacing-3xl: 3rem;     /* 48px */
  
  /* Border Radius */
  --radius-sm: 0.375rem;   /* 6px */
  --radius-md: 0.5rem;     /* 8px */
  --radius-lg: 0.75rem;    /* 12px */
  --radius-xl: 1rem;       /* 16px */
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  
  /* Typography */
  --font-size-xs: 0.75rem;    /* 12px */
  --font-size-sm: 0.875rem;   /* 14px */
  --font-size-base: 1rem;     /* 16px */
  --font-size-lg: 1.125rem;   /* 18px */
  --font-size-xl: 1.25rem;    /* 20px */
  --font-size-2xl: 1.5rem;    /* 24px */
  --font-size-3xl: 1.875rem;  /* 30px */
  
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
}

/* ===== UNIFIED COMPONENT STYLES ===== */

/* Button Styles - Consistent across app */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  line-height: 1.5;
  min-height: 32px;
}

.btn-primary {
  background-color: var(--color-primary-600);
  color: white;
  border-color: var(--color-primary-600);
}

.btn-primary:hover {
  background-color: var(--color-primary-700);
  border-color: var(--color-primary-700);
}

.btn-secondary {
  background-color: white;
  color: var(--color-neutral-700);
  border-color: var(--color-neutral-300);
}

.btn-secondary:hover {
  background-color: var(--color-neutral-50);
  border-color: var(--color-neutral-400);
}

.btn-success {
  background-color: var(--color-success);
  color: white;
  border-color: var(--color-success);
}

.btn-success:hover {
  background-color: var(--color-success-dark);
  border-color: var(--color-success-dark);
}

.btn-danger {
  background-color: var(--color-error);
  color: white;
  border-color: var(--color-error);
}

.btn-danger:hover {
  background-color: var(--color-error-dark);
  border-color: var(--color-error-dark);
}

/* Input Field Styles - Consistent across app */
.input-field {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-md);
  background-color: white;
  transition: all 0.2s ease;
  line-height: 1.5;
}

.input-field:hover {
  border-color: var(--color-neutral-400);
}

.input-field:focus {
  outline: none;
  border-color: var(--color-primary-500);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.input-field.error {
  border-color: var(--color-error);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

/* Label Styles */
.field-label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-neutral-700);
  margin-bottom: var(--spacing-xs);
  line-height: 1.4;
}

/* Card Styles - Consistent across app */
.card {
  background-color: white;
  border: 1px solid var(--color-neutral-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition: box-shadow 0.2s ease;
}

.card:hover {
  box-shadow: var(--shadow-md);
}

.card-header {
  padding: var(--spacing-lg);
  border-bottom: 1px solid var(--color-neutral-200);
  background: linear-gradient(to right, var(--color-neutral-50), white);
}

.card-body {
  padding: var(--spacing-lg);
}

.card-footer {
  padding: var(--spacing-lg);
  border-top: 1px solid var(--color-neutral-200);
  background-color: var(--color-neutral-50);
}

/* Status Badge Styles */
.badge {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-xs) var(--spacing-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-sm);
  line-height: 1;
}

.badge-success {
  background-color: var(--color-success-light);
  color: var(--color-success-dark);
  border: 1px solid var(--color-success);
}

.badge-error {
  background-color: var(--color-error-light);
  color: var(--color-error-dark);
  border: 1px solid var(--color-error);
}

.badge-warning {
  background-color: var(--color-warning-light);
  color: var(--color-warning-dark);
  border: 1px solid var(--color-warning);
}

.badge-info {
  background-color: var(--color-info-light);
  color: var(--color-info-dark);
  border: 1px solid var(--color-info);
}

/* Table Styles */
.table {
  width: 100%;
  border-collapse: collapse;
}

.table th {
  background-color: var(--color-neutral-50);
  color: var(--color-neutral-700);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  padding: var(--spacing-sm);
  border-bottom: 1px solid var(--color-neutral-200);
  text-align: left;
}

.table td {
  padding: var(--spacing-sm);
  border-bottom: 1px solid var(--color-neutral-100);
  font-size: var(--font-size-sm);
  color: var(--color-neutral-600);
}

.table tr:hover {
  background-color: var(--color-neutral-50);
  transition: background-color 0.2s ease;
}

/* Utility Classes for consistent spacing */
.mb-xs { margin-bottom: var(--spacing-xs); }
.mb-sm { margin-bottom: var(--spacing-sm); }
.mb-md { margin-bottom: var(--spacing-md); }
.mb-lg { margin-bottom: var(--spacing-lg); }
.mb-xl { margin-bottom: var(--spacing-xl); }

.mt-xs { margin-top: var(--spacing-xs); }
.mt-sm { margin-top: var(--spacing-sm); }
.mt-md { margin-top: var(--spacing-md); }
.mt-lg { margin-top: var(--spacing-lg); }
.mt-xl { margin-top: var(--spacing-xl); }

.p-xs { padding: var(--spacing-xs); }
.p-sm { padding: var(--spacing-sm); }
.p-md { padding: var(--spacing-md); }
.p-lg { padding: var(--spacing-lg); }
.p-xl { padding: var(--spacing-xl); }

/* Text color utilities using CSS variables */
.text-primary { color: var(--color-primary-600); }
.text-primary-light { color: var(--color-primary-400); }
.text-primary-dark { color: var(--color-primary-800); }

.text-neutral { color: var(--color-neutral-600); }
.text-neutral-light { color: var(--color-neutral-400); }
.text-neutral-dark { color: var(--color-neutral-800); }

.text-success { color: var(--color-success); }
.text-error { color: var(--color-error); }
.text-warning { color: var(--color-warning); }
.text-info { color: var(--color-info); }

/* ===== ADDITIONAL ENHANCED UTILITIES ===== */

/* Background color utilities */
.bg-primary { background-color: var(--color-primary-600); }
.bg-primary-light { background-color: var(--color-primary-100); }
.bg-primary-dark { background-color: var(--color-primary-800); }

.bg-neutral { background-color: var(--color-neutral-600); }
.bg-neutral-light { background-color: var(--color-neutral-100); }
.bg-neutral-dark { background-color: var(--color-neutral-800); }

.bg-success { background-color: var(--color-success); }
.bg-error { background-color: var(--color-error); }
.bg-warning { background-color: var(--color-warning); }
.bg-info { background-color: var(--color-info); }

/* Border color utilities */
.border-primary { border-color: var(--color-primary-600); }
.border-primary-light { border-color: var(--color-primary-300); }
.border-primary-dark { border-color: var(--color-primary-800); }

.border-neutral { border-color: var(--color-neutral-600); }
.border-neutral-light { border-color: var(--color-neutral-300); }
.border-neutral-dark { border-color: var(--color-neutral-800); }

.border-success { border-color: var(--color-success); }
.border-error { border-color: var(--color-error); }
.border-warning { border-color: var(--color-warning); }
.border-info { border-color: var(--color-info); }

/* Enhanced button variants */
.btn-sm {
  padding: var(--spacing-xs, 0.25rem) var(--spacing-sm, 0.5rem);
  font-size: var(--font-size-xs, 0.75rem);
  min-height: 28px;
}

.btn-lg {
  padding: var(--spacing-md, 0.75rem) var(--spacing-xl, 1.5rem);
  font-size: var(--font-size-base, 1rem);
  min-height: 40px;
}

.btn-outline {
  background-color: transparent;
  color: var(--color-primary-600);
  border-color: var(--color-primary-600);
}

.btn-outline:hover {
  background-color: var(--color-primary-600);
  color: white;
}

.btn-ghost {
  background-color: transparent;
  color: var(--color-neutral-600);
  border-color: transparent;
}

.btn-ghost:hover {
  background-color: var(--color-neutral-100);
  color: var(--color-neutral-800);
}

/* Enhanced input variants */
.input-field-sm {
  padding: var(--spacing-xs, 0.25rem) var(--spacing-sm, 0.5rem);
  font-size: var(--font-size-xs, 0.75rem);
}

.input-field-lg {
  padding: var(--spacing-md, 0.75rem) var(--spacing-lg, 1rem);
  font-size: var(--font-size-base, 1rem);
}

/* Enhanced card variants */
.card-elevated {
  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1));
}

.card-bordered {
  border: 2px solid var(--color-neutral-200, #e5e5e5);
}

.card-interactive {
  cursor: pointer;
  transition: all 0.2s ease;
}

.card-interactive:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1));
}

/* Enhanced badge variants */
.badge-sm {
  padding: var(--spacing-xs, 0.25rem);
  font-size: var(--font-size-xs, 0.75rem);
}

.badge-lg {
  padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);
  font-size: var(--font-size-sm, 0.875rem);
}

.badge-outline {
  background-color: transparent;
  border: 1px solid currentColor;
}

/* Enhanced table variants */
.table-striped tr:nth-child(even) {
  background-color: var(--color-neutral-50, #fafafa);
}

.table-compact th,
.table-compact td {
  padding: var(--spacing-xs, 0.25rem);
}

.table-bordered th,
.table-bordered td {
  border: 1px solid var(--color-neutral-200, #e5e5e5);
}

/* Enhanced spacing utilities */
.space-y-xs > * + * { margin-top: var(--spacing-xs, 0.25rem); }
.space-y-sm > * + * { margin-top: var(--spacing-sm, 0.5rem); }
.space-y-md > * + * { margin-top: var(--spacing-md, 0.75rem); }
.space-y-lg > * + * { margin-top: var(--spacing-lg, 1rem); }
.space-y-xl > * + * { margin-top: var(--spacing-xl, 1.5rem); }

.space-x-xs > * + * { margin-left: var(--spacing-xs, 0.25rem); }
.space-x-sm > * + * { margin-left: var(--spacing-sm, 0.5rem); }
.space-x-md > * + * { margin-left: var(--spacing-md, 0.75rem); }
.space-x-lg > * + * { margin-left: var(--spacing-lg, 1rem); }
.space-x-xl > * + * { margin-left: var(--spacing-xl, 1.5rem); }

/* Enhanced flex utilities */
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* Enhanced grid utilities */
.grid-auto-fit {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-lg, 1rem);
}

.grid-auto-fill {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--spacing-md, 0.75rem);
}

/* Enhanced responsive utilities */
@media (max-width: 640px) {
  .btn {
    padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);
    font-size: var(--font-size-xs, 0.75rem);
  }
  
  .card-body {
    padding: var(--spacing-md, 0.75rem);
  }
  
  .input-field {
    padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);
    font-size: var(--font-size-xs, 0.75rem);
  }
}

/* Enhanced focus and accessibility */
.focus-ring:focus {
  outline: 2px solid var(--color-primary-500, #10b981);
  outline-offset: 2px;
}

.focus-ring-error:focus {
  outline: 2px solid var(--color-error, #ef4444);
  outline-offset: 2px;
}

/* Enhanced animations */
.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

.slide-up {
  animation: slideUp 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* ===== FORM CONTAINER FIXES ===== */
/* Ensure form containers don't limit input width */
.form-container,
.form-wrapper,
.form-section,
.form-field,
.field-wrapper,
.field-container {
  width: 100% !important;
  max-width: 100% !important;
}

/* Force form fields to use full available width */
.form-field input,
.form-field select,
.form-field textarea,
.field-wrapper input,
.field-wrapper select,
.field-wrapper textarea,
.field-container input,
.field-container select,
.field-container textarea {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

/* ===== LAYOUT UTILITY CLASSES ===== */
/* Full width input utility class */
.input-full-width {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

/* Full width container utility class */
.container-full-width {
  width: 100% !important;
  max-width: 100% !important;
}

/* Force flex items to expand */
.flex-expand {
  flex: 1 1 !important;
  min-width: 0 !important;
  width: 100% !important;
}

/* ===== BREAKOUT UTILITY CLASSES ===== */
/* Force elements to break out of container constraints */
.breakout-width {
  width: 100vw !important;
  max-width: 100vw !important;
  margin-left: calc(-50vw + 50%) !important;
  margin-right: calc(-50vw + 50%) !important;
  box-sizing: border-box !important;
}

/* Force full width within parent container */
.full-width-parent {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* ===== SPECIFIC COMPONENT OVERRIDES ===== */
/* Override any card or container padding that might limit input width */
.card .nextui-input-wrapper,
.card .nextui-textarea-wrapper,
.card .nextui-select-wrapper,
.card input,
.card select,
.card textarea {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Override modal or popup container constraints */
.modal .nextui-input-wrapper,
.modal .nextui-textarea-wrapper,
.modal .nextui-select-wrapper,
.popup .nextui-input-wrapper,
.popup .nextui-textarea-wrapper,
.popup .nextui-select-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

/* Override any grid or flex container constraints */
.grid .nextui-input-wrapper,
.grid .nextui-textarea-wrapper,
.grid .nextui-select-wrapper,
.flex .nextui-input-wrapper,
.flex .nextui-textarea-wrapper,
.flex .nextui-select-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

/* ===== RESPONSIVE WIDTH ENFORCEMENT ===== */
/* Ensure full width on all screen sizes */
@media (max-width: 768px) {
  .nextui-input-wrapper,
  .nextui-textarea-wrapper,
  .nextui-select-wrapper,
  input,
  select,
  textarea {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }
}

@media (max-width: 480px) {
  .nextui-input-wrapper,
  .nextui-textarea-wrapper,
  .nextui-select-wrapper,
  input,
  select,
  textarea {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

/* Force consistent form element heights */
input,
select,
textarea,
.input-field,
.nextui-select-trigger,
.nextui-select-wrapper,
.nextui-input-wrapper,
.nextui-input,
.nextui-textarea {
  height: auto !important;
  min-height: 44px !important;
  max-height: none !important;
}

/* ===== COMPLETE NEXTUI OVERRIDE ===== */
/* Force NextUI components to match our design exactly */
.nextui-select-trigger,
.nextui-select-wrapper,
.nextui-input-wrapper,
.nextui-input,
.nextui-textarea {
  all: unset !important;
  width: 100% !important;
  padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem) !important;
  font-size: var(--font-size-sm, 0.875rem) !important;
  border: 2px solid var(--color-neutral-300, #d4d4d4) !important;
  border-radius: var(--radius-lg, 0.75rem) !important;
  background-color: white !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  line-height: 1.5 !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  position: relative !important;
  outline: none !important;
  min-height: 44px !important;
  display: flex !important;
  align-items: center !important;
  color: var(--color-neutral-800, #262626) !important;
  font-family: inherit !important;
  font-weight: var(--font-weight-normal, 400) !important;
  letter-spacing: 0.025em !important;
  box-sizing: border-box !important;
}

/* NextUI hover states */
.nextui-select-trigger:hover,
.nextui-select-wrapper:hover,
.nextui-input-wrapper:hover,
.nextui-input:hover,
.nextui-textarea:hover {
  border-color: var(--color-primary-400, #34d399) !important;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1) !important;
  transform: translateY(-1px) !important;
}

/* NextUI focus states */
.nextui-select-trigger:focus,
.nextui-select-wrapper:focus,
.nextui-input-wrapper:focus,
.nextui-input:focus,
.nextui-textarea:focus {
  outline: none !important;
  border-color: var(--color-primary-500, #10b981) !important;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15), 0 4px 6px rgba(16, 185, 129, 0.1) !important;
  transform: translateY(-1px) !important;
}

/* NextUI error states */
.nextui-select-trigger.error,
.nextui-select-wrapper.error,
.nextui-input-wrapper.error,
.nextui-input.error,
.nextui-textarea.error {
  border-color: var(--color-error, #ef4444) !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15), 0 2px 4px rgba(239, 68, 68, 0.1) !important;
}

/* NextUI success states */
.nextui-select-trigger.success,
.nextui-select-wrapper.success,
.nextui-input-wrapper.success,
.nextui-input.success,
.nextui-textarea.success {
  border-color: var(--color-success, #10b981) !important;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
}

/* NextUI disabled states */
.nextui-select-trigger:disabled,
.nextui-select-wrapper:disabled,
.nextui-input-wrapper:disabled,
.nextui-input:disabled,
.nextui-textarea:disabled {
  background-color: var(--color-neutral-100, #f5f5f5) !important;
  color: var(--color-neutral-500, #737373) !important;
  cursor: not-allowed !important;
  border-color: var(--color-neutral-200, #e5e5e5) !important;
  box-shadow: none !important;
  transform: none !important;
}

/* Override NextUI internal elements */
.nextui-select-trigger .nextui-select-value,
.nextui-select-trigger .nextui-select-arrow,
.nextui-input-wrapper .nextui-input,
.nextui-textarea-wrapper .nextui-textarea {
  all: unset !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  height: 100% !important;
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  font-family: inherit !important;
}

/* Ensure NextUI labels match our styling */
.nextui-input-wrapper .nextui-input-label,
.nextui-textarea-wrapper .nextui-textarea-label,
.nextui-select-wrapper .nextui-select-label {
  all: unset !important;
  display: block !important;
  font-size: var(--font-size-sm, 0.875rem) !important;
  font-weight: var(--font-weight-medium, 500) !important;
  color: var(--color-neutral-700, #404040) !important;
  margin-bottom: var(--spacing-xs, 0.25rem) !important;
  line-height: 1.4 !important;
  transition: color 0.2s ease !important;
}

/* NextUI label focus states */
.nextui-input-wrapper:focus-within .nextui-input-label,
.nextui-textarea-wrapper:focus-within .nextui-textarea-label,
.nextui-select-wrapper:focus-within .nextui-select-label {
  color: var(--color-primary-600, #059669) !important;
}

/* Override any remaining NextUI specific styles */
[data-slot="input"],
[data-slot="select"],
[data-slot="textarea"],
[data-slot="dropdown"] {
  all: unset !important;
}

/* Ensure consistent appearance across all browsers */
* {
  box-sizing: border-box;
}

/* ===== SIMPLE HORIZONTAL FORM LAYOUT ===== */
/* Easy-to-use class for Cost and Cost Unit layout */
.cost-form-row {
  display: flex;
  gap: var(--spacing-lg, 1rem);
  align-items: flex-start;
  margin-bottom: var(--spacing-lg, 1rem);
}

.cost-form-row .cost-field {
  flex: 1 1;
  margin-bottom: 0;
}

.cost-form-row .cost-field label {
  display: block;
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  color: var(--color-neutral-700, #404040);
  margin-bottom: var(--spacing-xs, 0.25rem);
  line-height: 1.4;
}

.cost-form-row .cost-field input,
.cost-form-row .cost-field select,
.cost-form-row .cost-field .nextui-select-trigger,
.cost-form-row .cost-field .nextui-select-wrapper {
  width: 100%;
  padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);
  font-size: var(--font-size-sm, 0.875rem);
  border: 2px solid var(--color-neutral-300, #d4d4d4);
  border-radius: var(--radius-lg, 0.75rem);
  background-color: white;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  line-height: 1.5;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  min-height: 44px;
  color: var(--color-neutral-800, #262626);
}

.cost-form-row .cost-field input:hover,
.cost-form-row .cost-field select:hover,
.cost-form-row .cost-field .nextui-select-trigger:hover,
.cost-form-row .cost-field .nextui-select-wrapper:hover {
  border-color: var(--color-primary-400, #34d399);
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1);
  transform: translateY(-1px);
}

.cost-form-row .cost-field input:focus,
.cost-form-row .cost-field select:focus,
.cost-form-row .cost-field .nextui-select-trigger:focus,
.cost-form-row .cost-field .nextui-select-wrapper:focus {
  outline: none;
  border-color: var(--color-primary-500, #10b981);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15), 0 4px 6px rgba(16, 185, 129, 0.1);
  transform: translateY(-1px);
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .cost-form-row {
    flex-direction: column;
    gap: var(--spacing-md, 0.75rem);
  }
  
  .cost-form-row .cost-field {
    margin-bottom: var(--spacing-md, 0.75rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA,yDAAyD;AACzD,oEAAoE;AACpE;;;;;;;;;;;;EAYE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,2CAA2C;AAC3C;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA,yDAAyD;AACzD;;;;;;EAME,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;;;;EAIE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA,mDAAmD;AACnD;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA,wCAAwC;AACxC,2EAA2E;AAC3E;;;;;;;;;;;EAWE,iCAAiC;EACjC,qCAAqC;EACrC,kCAAkC;EAClC,+BAA6B;EAC7B,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;;;;;;;;EAQE,iCAAiC;EACjC,qCAAqC;EACrC,kCAAkC;EAClC,+BAA6B;AAC/B;;AAEA,wCAAwC;AACxC;;;EAGE,iCAAiC;EACjC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,0CAA0C;;AAE1C,mCAAmC;AACnC,0CAA0C;AAC1C;;;EAGE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;;;EAGE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;;;EAGE,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;;;EAGE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;;;EAGE,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;EAGE,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;;EAGE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;;;EAGE,mCAAmC;EACnC,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;;;EAGE,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;;;EAGE,6CAA6C;EAC7C,2CAA2C;EAC3C,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;;;EAGE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;;;EAGE,6CAA6C;EAC7C,wCAAwC;EACxC,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;;;EAGE,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;;;EAGE,2BAA2B;EAC3B,oCAAoC;EACpC,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;;EAGE,gCAAgC;EAChC,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;;;EAGE,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;;EAGE,sCAAsC;EACtC,mDAAmD;AACrD;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB,EAAE,2BAA2B;EACnD,WAAW,EAAE,qBAAqB;EAClC,sBAAsB,EAAE,iBAAiB;EACzC,YAAY,EAAE,kCAAkC;EAChD,kBAAkB,EAAE,sCAAsC;EAC1D,YAAY,EAAE,2BAA2B;EACzC,aAAa,EAAE,4BAA4B;AAC7C;;AAEA,+CAA+C,aAAa,EAAE;;AAE9D,UAAU,YAAY,EAAE;AACxB,UAAU,iBAAiB,EAAE;AAC7B,WAAW,WAAW,EAAE;AACxB,QAAQ,cAAc,EAAE;AACxB,OAAO,UAAU,EAAE;;AAEnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB;IACE,aAAa;EACf;EACA,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,8CAA8C;;AAE9C,wDAAwD;AACxD;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;EACA,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA,sDAAsD;;AAEtD,gDAAgD;AAChD;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,2CAA2C;EAC3C,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;;EAE1B,kBAAkB;EAClB,qBAAqB,IAAI,QAAQ;EACjC,oBAAoB,KAAK,QAAQ;EACjC,qBAAqB,IAAI,SAAS;EAClC,kBAAkB,OAAO,SAAS;EAClC,oBAAoB,KAAK,SAAS;EAClC,mBAAmB,MAAM,SAAS;EAClC,mBAAmB,MAAM,SAAS;;EAElC,kBAAkB;EAClB,qBAAqB,IAAI,QAAQ;EACjC,mBAAmB,MAAM,QAAQ;EACjC,oBAAoB,KAAK,SAAS;EAClC,iBAAiB,QAAQ,SAAS;;EAElC,YAAY;EACZ,4CAA4C;EAC5C,8CAA8C;EAC9C,gDAAgD;;EAEhD,eAAe;EACf,uBAAuB,KAAK,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,sBAAsB,MAAM,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,yBAAyB,GAAG,SAAS;;EAErC,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,yCAAyC;;AAEzC,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,4CAA4C;EAC5C,8BAA8B;EAC9B,0CAA0C;EAC1C,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,qEAAqE;AACvE;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;EAC5C,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wCAAwC;EACxC,8BAA8B;EAC9B,0BAA0B;EAC1B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA,2CAA2C;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;;AAE3C,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;;AAExC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;;AAEpC,6CAA6C;AAC7C,gBAAgB,+BAA+B,EAAE;AACjD,sBAAsB,+BAA+B,EAAE;AACvD,qBAAqB,+BAA+B,EAAE;;AAEtD,gBAAgB,+BAA+B,EAAE;AACjD,sBAAsB,+BAA+B,EAAE;AACvD,qBAAqB,+BAA+B,EAAE;;AAEtD,gBAAgB,2BAA2B,EAAE;AAC7C,cAAc,yBAAyB,EAAE;AACzC,gBAAgB,2BAA2B,EAAE;AAC7C,aAAa,wBAAwB,EAAE;;AAEvC,8CAA8C;;AAE9C,+BAA+B;AAC/B,cAAc,0CAA0C,EAAE;AAC1D,oBAAoB,0CAA0C,EAAE;AAChE,mBAAmB,0CAA0C,EAAE;;AAE/D,cAAc,0CAA0C,EAAE;AAC1D,oBAAoB,0CAA0C,EAAE;AAChE,mBAAmB,0CAA0C,EAAE;;AAE/D,cAAc,sCAAsC,EAAE;AACtD,YAAY,oCAAoC,EAAE;AAClD,cAAc,sCAAsC,EAAE;AACtD,WAAW,mCAAmC,EAAE;;AAEhD,2BAA2B;AAC3B,kBAAkB,sCAAsC,EAAE;AAC1D,wBAAwB,sCAAsC,EAAE;AAChE,uBAAuB,sCAAsC,EAAE;;AAE/D,kBAAkB,sCAAsC,EAAE;AAC1D,wBAAwB,sCAAsC,EAAE;AAChE,uBAAuB,sCAAsC,EAAE;;AAE/D,kBAAkB,kCAAkC,EAAE;AACtD,gBAAgB,gCAAgC,EAAE;AAClD,kBAAkB,kCAAkC,EAAE;AACtD,eAAe,+BAA+B,EAAE;;AAEhD,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,2DAA2D;EAC3D,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;EACE,iEAAiE;AACnE;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iEAAiE;AACnE;;AAEA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,kDAAkD;AACpD;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA,+BAA+B;AAC/B,sBAAsB,sCAAsC,EAAE;AAC9D,sBAAsB,qCAAqC,EAAE;AAC7D,sBAAsB,sCAAsC,EAAE;AAC9D,sBAAsB,mCAAmC,EAAE;AAC3D,sBAAsB,qCAAqC,EAAE;;AAE7D,sBAAsB,uCAAuC,EAAE;AAC/D,sBAAsB,sCAAsC,EAAE;AAC9D,sBAAsB,uCAAuC,EAAE;AAC/D,sBAAsB,oCAAoC,EAAE;AAC5D,sBAAsB,sCAAsC,EAAE;;AAE9D,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE;IACE,6DAA6D;IAC7D,uCAAuC;EACzC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,6DAA6D;IAC7D,uCAAuC;EACzC;AACF;;AAEA,qCAAqC;AACrC;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,qCAAqC;AACrC,mDAAmD;AACnD;;;;;;EAME,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;;;;;;;;;EASE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC,mCAAmC;AACnC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,oBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC,yDAAyD;AACzD;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C,wEAAwE;AACxE;;;;;;EAME,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;;;;;;EAME,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;;;;;;EAME,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C,0CAA0C;AAC1C;EACE;;;;;;IAME,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA;EACE;;;;;;IAME,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA,0CAA0C;AAC1C;;;;;;;;;EASE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC,wDAAwD;AACxD;;;;;EAKE,qBAAqB;EACrB,sBAAsB;EACtB,wEAAwE;EACxE,mDAAmD;EACnD,8DAA8D;EAC9D,mDAAmD;EACnD,kCAAkC;EAClC,4DAA4D;EAC5D,2BAA2B;EAC3B,oDAAoD;EACpD,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,mDAAmD;EACnD,+BAA+B;EAC/B,sDAAsD;EACtD,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;;;;;EAKE,0DAA0D;EAC1D,wDAAwD;EACxD,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;;;;;EAKE,wBAAwB;EACxB,0DAA0D;EAC1D,4FAA4F;EAC5F,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;;;;;EAKE,oDAAoD;EACpD,0FAA0F;AAC5F;;AAEA,0BAA0B;AAC1B;;;;;EAKE,sDAAsD;EACtD,wDAAwD;AAC1D;;AAEA,2BAA2B;AAC3B;;;;;EAKE,8DAA8D;EAC9D,mDAAmD;EACnD,8BAA8B;EAC9B,0DAA0D;EAC1D,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;;;;EAIE,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C;;;EAGE,qBAAqB;EACrB,yBAAyB;EACzB,mDAAmD;EACnD,sDAAsD;EACtD,mDAAmD;EACnD,oDAAoD;EACpD,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;;;EAGE,mDAAmD;AACrD;;AAEA,kDAAkD;AAClD;;;;EAIE,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C,oDAAoD;AACpD;EACE,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,2CAA2C;EAC3C,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,6DAA6D;EAC7D,wCAAwC;EACxC,mDAAmD;EACnD,wCAAwC;EACxC,uBAAuB;EACvB,iDAAiD;EACjD,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;;;EAIE,+CAA+C;EAC/C,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;;;;EAIE,aAAa;EACb,+CAA+C;EAC/C,iFAAiF;EACjF,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE;IACE,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":["@import 'codemirror/lib/codemirror.css';\n@import 'codemirror/theme/material.css';\n\n/* ===== AGGRESSIVE INPUT FIELD WIDTH ENFORCEMENT ===== */\n/* Force ALL input fields to be full width regardless of container */\ninput,\nselect,\ntextarea,\n.input-field,\n.nextui-input,\n.nextui-textarea,\n.nextui-select-trigger,\n.nextui-select-wrapper,\n.nextui-input-wrapper,\n[data-slot=\"input\"],\n[data-slot=\"textarea\"],\n[data-slot=\"select\"] {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* Force input containers to expand fully */\n.nextui-input-wrapper,\n.nextui-textarea-wrapper,\n.nextui-select-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n/* Override any flex constraints that might limit width */\n.nextui-input-wrapper > div,\n.nextui-input-wrapper > span,\n.nextui-textarea-wrapper > div,\n.nextui-textarea-wrapper > span,\n.nextui-select-wrapper > div,\n.nextui-select-wrapper > span {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n/* Force internal input elements to expand */\n.nextui-input-wrapper input,\n.nextui-input-wrapper textarea,\n.nextui-textarea-wrapper textarea,\n.nextui-select-wrapper select {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n/* Target the exact structure from the screenshot */\n.space-y-6 input,\n.space-y-6 .nextui-input-wrapper,\n.space-y-6 .nextui-input-wrapper > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n/* ===== FORCE NEXTUI FULL WIDTH ===== */\n/* Target NextUI components with maximum specificity and force full width */\n.nextui-input-wrapper,\n.nextui-input-wrapper[class*=\"inputWrapper\"],\n.nextui-input-wrapper[class*=\"wrapper\"],\n.nextui-input-wrapper[class*=\"base\"],\n.nextui-input-wrapper[class*=\"input\"],\n.nextui-input-wrapper[class*=\"field\"],\n.nextui-input-wrapper.bg-white,\n.nextui-input-wrapper.border-gray-300,\n.nextui-input-wrapper.h-10,\n.nextui-input-wrapper.w-full,\n.nextui-input-wrapper.max-w-full {\n  width: 100% !important !important;\n  max-width: 100% !important !important;\n  min-width: 0 !important !important;\n  flex: 1 !important !important;\n  display: flex !important !important;\n  align-items: center !important !important;\n}\n\n/* Force all child elements to expand */\n.nextui-input-wrapper > *,\n.nextui-input-wrapper > div,\n.nextui-input-wrapper > span,\n.nextui-input-wrapper > input,\n.nextui-input-wrapper > textarea,\n.nextui-input-wrapper > select,\n.nextui-input-wrapper > button,\n.nextui-input-wrapper > label {\n  width: 100% !important !important;\n  max-width: 100% !important !important;\n  min-width: 0 !important !important;\n  flex: 1 !important !important;\n}\n\n/* Override any Tailwind width classes */\n.nextui-input-wrapper[class*=\"w-\"],\n.nextui-input-wrapper[class*=\"max-w-\"],\n.nextui-input-wrapper[class*=\"min-w-\"] {\n  width: 100% !important !important;\n  max-width: 100% !important !important;\n  min-width: 0 !important !important;\n}\n\n/* Remove redundant information displays */\n\n/* ===== POPUP IMPROVEMENTS ===== */\n/* Remove redundant information displays */\n.modal .info-banner,\n.popup .info-banner,\n[role=\"dialog\"] .info-banner {\n  /* Hide redundant total count banners */\n  display: none !important;\n}\n\n/* Optimize search bar styling */\n.modal .search-input,\n.popup .search-input,\n[role=\"dialog\"] .search-input {\n  border: 2px solid #d4d4d4 !important;\n  border-radius: 0.5rem !important;\n  padding: 0.75rem 1rem !important;\n  font-size: 0.875rem !important;\n  transition: all 0.2s ease !important;\n}\n\n.modal .search-input:focus,\n.popup .search-input:focus,\n[role=\"dialog\"] .search-input:focus {\n  border-color: #10b981 !important;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;\n  outline: none !important;\n}\n\n/* Optimize item list styling */\n.modal .item-list,\n.popup .item-list,\n[role=\"dialog\"] .item-list {\n  max-height: 60vh !important;\n  overflow-y: auto !important;\n  padding: 0.5rem 0 !important;\n}\n\n/* Remove duplicate pagination information */\n.modal .pagination-info,\n.popup .pagination-info,\n[role=\"dialog\"] .pagination-info {\n  /* Keep only essential pagination info */\n  font-size: 0.875rem !important;\n  color: #6b7280 !important;\n}\n\n/* Hide redundant total count at bottom */\n.modal .total-count-bottom,\n.popup .total-count-bottom,\n[role=\"dialog\"] .total-count-bottom {\n  display: none !important;\n}\n\n/* Optimize navigation buttons */\n.modal .nav-buttons,\n.popup .nav-buttons,\n[role=\"dialog\"] .nav-buttons {\n  display: flex !important;\n  gap: 0.5rem !important;\n  align-items: center !important;\n}\n\n.modal .nav-button,\n.popup .nav-button,\n[role=\"dialog\"] .nav-button {\n  padding: 0.5rem 1rem !important;\n  border-radius: 0.375rem !important;\n  font-size: 0.875rem !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n}\n\n.modal .nav-button:disabled,\n.popup .nav-button:disabled,\n[role=\"dialog\"] .nav-button:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n/* Ensure single close button */\n.modal .close-button,\n.popup .close-button,\n[role=\"dialog\"] .close-button {\n  /* Remove duplicate close buttons */\n  position: absolute !important;\n  top: 1rem !important;\n  right: 1rem !important;\n  z-index: 10 !important;\n}\n\n/* Hide any additional close elements */\n.modal .close-element:not(:first-child),\n.popup .close-element:not(:first-child),\n[role=\"dialog\"] .close-element:not(:first-child) {\n  display: none !important;\n}\n\n/* Optimize modal header */\n.modal .modal-header,\n.popup .modal-header,\n[role=\"dialog\"] .modal-header {\n  padding: 1.5rem 1.5rem 1rem 1.5rem !important;\n  border-bottom: 1px solid #e5e7eb !important;\n  background: #f9fafb !important;\n  border-radius: 0.75rem 0.75rem 0 0 !important;\n}\n\n/* Optimize modal body */\n.modal .modal-body,\n.popup .modal-body,\n[role=\"dialog\"] .modal-body {\n  padding: 1.5rem !important;\n  max-height: 70vh !important;\n  overflow-y: auto !important;\n}\n\n/* Optimize modal footer */\n.modal .modal-footer,\n.popup .modal-footer,\n[role=\"dialog\"] .modal-footer {\n  padding: 1rem 1.5rem 1.5rem 1.5rem !important;\n  border-top: 1px solid #e5e7eb !important;\n  background: #f9fafb !important;\n  border-radius: 0 0 0.75rem 0.75rem !important;\n}\n\n/* Remove redundant text displays */\n.modal .redundant-text,\n.popup .redundant-text,\n[role=\"dialog\"] .redundant-text {\n  display: none !important;\n}\n\n/* Optimize item display */\n.modal .item,\n.popup .item,\n[role=\"dialog\"] .item {\n  padding: 0.75rem !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 0.375rem !important;\n  margin-bottom: 0.5rem !important;\n  transition: all 0.2s ease !important;\n  cursor: pointer !important;\n}\n\n.modal .item:hover,\n.popup .item:hover,\n[role=\"dialog\"] .item:hover {\n  border-color: #10b981 !important;\n  background: #f0fdf4 !important;\n  transform: translateY(-1px) !important;\n}\n\n/* Ensure consistent button styling */\n.modal button,\n.popup button,\n[role=\"dialog\"] button {\n  border-radius: 0.375rem !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n}\n\n.modal button:not(:disabled):hover,\n.popup button:not(:disabled):hover,\n[role=\"dialog\"] button:not(:disabled):hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* ===== EXISTING STYLES - DO NOT MODIFY ===== */\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.dark-textfield {\n  background-color: #000; /* Black background color */\n  color: #fff; /* White text color */\n  border: 1px solid #666; /* Border color */\n  padding: 8px; /* Padding around the text field */\n  border-radius: 4px; /* Border radius for rounded corners */\n  width: 300px; /* Adjust width as needed */\n  outline: none; /* Remove outline on focus */\n}\n\n.react-codemirror2 > .CodeMirror:first-child { display: none; }\n\n.string { color: green; }\n.number { color: darkorange; }\n.boolean { color: blue; }\n.null { color: magenta; }\n.key { color: red; }\n\n.custom-dropdown-menu {\n  max-height: 300px;\n  overflow-y: auto;\n  max-width: 300px;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  /* scrollbar-width: thin; */\n}\n\n.hide-scrollbar{\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.custom-scrollbar{\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: transparent;\n    z-index: 1000;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #cbd5e0;\n    border-radius: 4px;\n    z-index: 1000;\n    border: 1px solid #e2e8f0;\n  }\n  &::-webkit-scrollbar-thumb:hover {\n    background: #a0aec0;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n}\n\n/* Enhanced scrollbar for sidebar navigation */\n\n/* Modal improvements for better scrolling and display */\n.modal-content-scrollable {\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-body-scrollable {\n  max-height: calc(90vh - 120px);\n  overflow-y: auto;\n  padding: 1.5rem;\n}\n\n/* Custom scrollbar for modal content */\n.modal-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e0 #f7fafc;\n}\n\n.modal-scrollbar::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modal-scrollbar::-webkit-scrollbar-track {\n  background: #f7fafc;\n  border-radius: 4px;\n}\n\n.modal-scrollbar::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.modal-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #a0aec0;\n}\n\n.sidebar-scrollbar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    background-color: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #d1d5db;\n    border-radius: 3px;\n    border: 1px solid #f3f4f6;\n  }\n  &::-webkit-scrollbar-thumb:hover {\n    background: #9ca3af;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n}\n\n/* Hide scrollbar for main content area */\n.main-content-scroll {\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n/* .bg-overlay\\/50 {\n  background-color: transparent;\n} */\n \nbody > iframe {\n  display: none;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #a0aec0;\n  border-radius: 4px;\n  border: 2px solid transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #718096;\n}\n\n::-webkit-scrollbar-thumb:active {\n  background-color: #4a5568;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.skeleton-chip {\n  background: linear-gradient(\n    90deg,\n    rgba(238, 238, 238, 0.3) 25%,\n    rgba(243, 241, 241, 0.846) 50%,\n    rgba(238, 238, 238, 0.3) 75%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite ease-in-out;\n}\n\n/* ===== UNIFIED DESIGN SYSTEM - NEW ADDITIONS ===== */\n\n/* CSS Custom Properties for consistent colors */\n:root {\n  /* Primary Colors - Emerald Theme */\n  --color-primary-50: #ecfdf5;\n  --color-primary-100: #d1fae5;\n  --color-primary-200: #a7f3d0;\n  --color-primary-300: #6ee7b7;\n  --color-primary-400: #34d399;\n  --color-primary-500: #10b981;\n  --color-primary-600: #059669;\n  --color-primary-700: #047857;\n  --color-primary-800: #065f46;\n  --color-primary-900: #064e3b;\n  \n  /* Neutral Colors - Consistent across app */\n  --color-neutral-50: #fafafa;\n  --color-neutral-100: #f5f5f5;\n  --color-neutral-200: #e5e5e5;\n  --color-neutral-300: #d4d4d4;\n  --color-neutral-400: #a3a3a3;\n  --color-neutral-500: #737373;\n  --color-neutral-600: #525252;\n  --color-neutral-700: #404040;\n  --color-neutral-800: #262626;\n  --color-neutral-900: #171717;\n  \n  /* Semantic Colors */\n  --color-success: #10b981;\n  --color-success-light: #d1fae5;\n  --color-success-dark: #047857;\n  --color-error: #ef4444;\n  --color-error-light: #fee2e2;\n  --color-error-dark: #dc2626;\n  --color-warning: #f59e0b;\n  --color-warning-light: #fef3c7;\n  --color-warning-dark: #d97706;\n  --color-info: #3b82f6;\n  --color-info-light: #dbeafe;\n  --color-info-dark: #2563eb;\n  \n  /* Spacing Scale */\n  --spacing-xs: 0.25rem;   /* 4px */\n  --spacing-sm: 0.5rem;    /* 8px */\n  --spacing-md: 0.75rem;   /* 12px */\n  --spacing-lg: 1rem;      /* 16px */\n  --spacing-xl: 1.5rem;    /* 24px */\n  --spacing-2xl: 2rem;     /* 32px */\n  --spacing-3xl: 3rem;     /* 48px */\n  \n  /* Border Radius */\n  --radius-sm: 0.375rem;   /* 6px */\n  --radius-md: 0.5rem;     /* 8px */\n  --radius-lg: 0.75rem;    /* 12px */\n  --radius-xl: 1rem;       /* 16px */\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  \n  /* Typography */\n  --font-size-xs: 0.75rem;    /* 12px */\n  --font-size-sm: 0.875rem;   /* 14px */\n  --font-size-base: 1rem;     /* 16px */\n  --font-size-lg: 1.125rem;   /* 18px */\n  --font-size-xl: 1.25rem;    /* 20px */\n  --font-size-2xl: 1.5rem;    /* 24px */\n  --font-size-3xl: 1.875rem;  /* 30px */\n  \n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n}\n\n/* ===== UNIFIED COMPONENT STYLES ===== */\n\n/* Button Styles - Consistent across app */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  border-radius: var(--radius-md);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  line-height: 1.5;\n  min-height: 32px;\n}\n\n.btn-primary {\n  background-color: var(--color-primary-600);\n  color: white;\n  border-color: var(--color-primary-600);\n}\n\n.btn-primary:hover {\n  background-color: var(--color-primary-700);\n  border-color: var(--color-primary-700);\n}\n\n.btn-secondary {\n  background-color: white;\n  color: var(--color-neutral-700);\n  border-color: var(--color-neutral-300);\n}\n\n.btn-secondary:hover {\n  background-color: var(--color-neutral-50);\n  border-color: var(--color-neutral-400);\n}\n\n.btn-success {\n  background-color: var(--color-success);\n  color: white;\n  border-color: var(--color-success);\n}\n\n.btn-success:hover {\n  background-color: var(--color-success-dark);\n  border-color: var(--color-success-dark);\n}\n\n.btn-danger {\n  background-color: var(--color-error);\n  color: white;\n  border-color: var(--color-error);\n}\n\n.btn-danger:hover {\n  background-color: var(--color-error-dark);\n  border-color: var(--color-error-dark);\n}\n\n/* Input Field Styles - Consistent across app */\n.input-field {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-md);\n  background-color: white;\n  transition: all 0.2s ease;\n  line-height: 1.5;\n}\n\n.input-field:hover {\n  border-color: var(--color-neutral-400);\n}\n\n.input-field:focus {\n  outline: none;\n  border-color: var(--color-primary-500);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.input-field.error {\n  border-color: var(--color-error);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n/* Label Styles */\n.field-label {\n  display: block;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-neutral-700);\n  margin-bottom: var(--spacing-xs);\n  line-height: 1.4;\n}\n\n/* Card Styles - Consistent across app */\n.card {\n  background-color: white;\n  border: 1px solid var(--color-neutral-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow 0.2s ease;\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.card-header {\n  padding: var(--spacing-lg);\n  border-bottom: 1px solid var(--color-neutral-200);\n  background: linear-gradient(to right, var(--color-neutral-50), white);\n}\n\n.card-body {\n  padding: var(--spacing-lg);\n}\n\n.card-footer {\n  padding: var(--spacing-lg);\n  border-top: 1px solid var(--color-neutral-200);\n  background-color: var(--color-neutral-50);\n}\n\n/* Status Badge Styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--spacing-xs) var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  border-radius: var(--radius-sm);\n  line-height: 1;\n}\n\n.badge-success {\n  background-color: var(--color-success-light);\n  color: var(--color-success-dark);\n  border: 1px solid var(--color-success);\n}\n\n.badge-error {\n  background-color: var(--color-error-light);\n  color: var(--color-error-dark);\n  border: 1px solid var(--color-error);\n}\n\n.badge-warning {\n  background-color: var(--color-warning-light);\n  color: var(--color-warning-dark);\n  border: 1px solid var(--color-warning);\n}\n\n.badge-info {\n  background-color: var(--color-info-light);\n  color: var(--color-info-dark);\n  border: 1px solid var(--color-info);\n}\n\n/* Table Styles */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th {\n  background-color: var(--color-neutral-50);\n  color: var(--color-neutral-700);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-sm);\n  padding: var(--spacing-sm);\n  border-bottom: 1px solid var(--color-neutral-200);\n  text-align: left;\n}\n\n.table td {\n  padding: var(--spacing-sm);\n  border-bottom: 1px solid var(--color-neutral-100);\n  font-size: var(--font-size-sm);\n  color: var(--color-neutral-600);\n}\n\n.table tr:hover {\n  background-color: var(--color-neutral-50);\n  transition: background-color 0.2s ease;\n}\n\n/* Utility Classes for consistent spacing */\n.mb-xs { margin-bottom: var(--spacing-xs); }\n.mb-sm { margin-bottom: var(--spacing-sm); }\n.mb-md { margin-bottom: var(--spacing-md); }\n.mb-lg { margin-bottom: var(--spacing-lg); }\n.mb-xl { margin-bottom: var(--spacing-xl); }\n\n.mt-xs { margin-top: var(--spacing-xs); }\n.mt-sm { margin-top: var(--spacing-sm); }\n.mt-md { margin-top: var(--spacing-md); }\n.mt-lg { margin-top: var(--spacing-lg); }\n.mt-xl { margin-top: var(--spacing-xl); }\n\n.p-xs { padding: var(--spacing-xs); }\n.p-sm { padding: var(--spacing-sm); }\n.p-md { padding: var(--spacing-md); }\n.p-lg { padding: var(--spacing-lg); }\n.p-xl { padding: var(--spacing-xl); }\n\n/* Text color utilities using CSS variables */\n.text-primary { color: var(--color-primary-600); }\n.text-primary-light { color: var(--color-primary-400); }\n.text-primary-dark { color: var(--color-primary-800); }\n\n.text-neutral { color: var(--color-neutral-600); }\n.text-neutral-light { color: var(--color-neutral-400); }\n.text-neutral-dark { color: var(--color-neutral-800); }\n\n.text-success { color: var(--color-success); }\n.text-error { color: var(--color-error); }\n.text-warning { color: var(--color-warning); }\n.text-info { color: var(--color-info); }\n\n/* ===== ADDITIONAL ENHANCED UTILITIES ===== */\n\n/* Background color utilities */\n.bg-primary { background-color: var(--color-primary-600); }\n.bg-primary-light { background-color: var(--color-primary-100); }\n.bg-primary-dark { background-color: var(--color-primary-800); }\n\n.bg-neutral { background-color: var(--color-neutral-600); }\n.bg-neutral-light { background-color: var(--color-neutral-100); }\n.bg-neutral-dark { background-color: var(--color-neutral-800); }\n\n.bg-success { background-color: var(--color-success); }\n.bg-error { background-color: var(--color-error); }\n.bg-warning { background-color: var(--color-warning); }\n.bg-info { background-color: var(--color-info); }\n\n/* Border color utilities */\n.border-primary { border-color: var(--color-primary-600); }\n.border-primary-light { border-color: var(--color-primary-300); }\n.border-primary-dark { border-color: var(--color-primary-800); }\n\n.border-neutral { border-color: var(--color-neutral-600); }\n.border-neutral-light { border-color: var(--color-neutral-300); }\n.border-neutral-dark { border-color: var(--color-neutral-800); }\n\n.border-success { border-color: var(--color-success); }\n.border-error { border-color: var(--color-error); }\n.border-warning { border-color: var(--color-warning); }\n.border-info { border-color: var(--color-info); }\n\n/* Enhanced button variants */\n.btn-sm {\n  padding: var(--spacing-xs, 0.25rem) var(--spacing-sm, 0.5rem);\n  font-size: var(--font-size-xs, 0.75rem);\n  min-height: 28px;\n}\n\n.btn-lg {\n  padding: var(--spacing-md, 0.75rem) var(--spacing-xl, 1.5rem);\n  font-size: var(--font-size-base, 1rem);\n  min-height: 40px;\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--color-primary-600);\n  border-color: var(--color-primary-600);\n}\n\n.btn-outline:hover {\n  background-color: var(--color-primary-600);\n  color: white;\n}\n\n.btn-ghost {\n  background-color: transparent;\n  color: var(--color-neutral-600);\n  border-color: transparent;\n}\n\n.btn-ghost:hover {\n  background-color: var(--color-neutral-100);\n  color: var(--color-neutral-800);\n}\n\n/* Enhanced input variants */\n.input-field-sm {\n  padding: var(--spacing-xs, 0.25rem) var(--spacing-sm, 0.5rem);\n  font-size: var(--font-size-xs, 0.75rem);\n}\n\n.input-field-lg {\n  padding: var(--spacing-md, 0.75rem) var(--spacing-lg, 1rem);\n  font-size: var(--font-size-base, 1rem);\n}\n\n/* Enhanced card variants */\n.card-elevated {\n  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1));\n}\n\n.card-bordered {\n  border: 2px solid var(--color-neutral-200, #e5e5e5);\n}\n\n.card-interactive {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.card-interactive:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1));\n}\n\n/* Enhanced badge variants */\n.badge-sm {\n  padding: var(--spacing-xs, 0.25rem);\n  font-size: var(--font-size-xs, 0.75rem);\n}\n\n.badge-lg {\n  padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\n.badge-outline {\n  background-color: transparent;\n  border: 1px solid currentColor;\n}\n\n/* Enhanced table variants */\n.table-striped tr:nth-child(even) {\n  background-color: var(--color-neutral-50, #fafafa);\n}\n\n.table-compact th,\n.table-compact td {\n  padding: var(--spacing-xs, 0.25rem);\n}\n\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid var(--color-neutral-200, #e5e5e5);\n}\n\n/* Enhanced spacing utilities */\n.space-y-xs > * + * { margin-top: var(--spacing-xs, 0.25rem); }\n.space-y-sm > * + * { margin-top: var(--spacing-sm, 0.5rem); }\n.space-y-md > * + * { margin-top: var(--spacing-md, 0.75rem); }\n.space-y-lg > * + * { margin-top: var(--spacing-lg, 1rem); }\n.space-y-xl > * + * { margin-top: var(--spacing-xl, 1.5rem); }\n\n.space-x-xs > * + * { margin-left: var(--spacing-xs, 0.25rem); }\n.space-x-sm > * + * { margin-left: var(--spacing-sm, 0.5rem); }\n.space-x-md > * + * { margin-left: var(--spacing-md, 0.75rem); }\n.space-x-lg > * + * { margin-left: var(--spacing-lg, 1rem); }\n.space-x-xl > * + * { margin-left: var(--spacing-xl, 1.5rem); }\n\n/* Enhanced flex utilities */\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.flex-end {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* Enhanced grid utilities */\n.grid-auto-fit {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-lg, 1rem);\n}\n\n.grid-auto-fill {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: var(--spacing-md, 0.75rem);\n}\n\n/* Enhanced responsive utilities */\n@media (max-width: 640px) {\n  .btn {\n    padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);\n    font-size: var(--font-size-xs, 0.75rem);\n  }\n  \n  .card-body {\n    padding: var(--spacing-md, 0.75rem);\n  }\n  \n  .input-field {\n    padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);\n    font-size: var(--font-size-xs, 0.75rem);\n  }\n}\n\n/* Enhanced focus and accessibility */\n.focus-ring:focus {\n  outline: 2px solid var(--color-primary-500, #10b981);\n  outline-offset: 2px;\n}\n\n.focus-ring-error:focus {\n  outline: 2px solid var(--color-error, #ef4444);\n  outline-offset: 2px;\n}\n\n/* Enhanced animations */\n.fade-in {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.slide-up {\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* ===== FORM CONTAINER FIXES ===== */\n/* Ensure form containers don't limit input width */\n.form-container,\n.form-wrapper,\n.form-section,\n.form-field,\n.field-wrapper,\n.field-container {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n/* Force form fields to use full available width */\n.form-field input,\n.form-field select,\n.form-field textarea,\n.field-wrapper input,\n.field-wrapper select,\n.field-wrapper textarea,\n.field-container input,\n.field-container select,\n.field-container textarea {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n/* ===== LAYOUT UTILITY CLASSES ===== */\n/* Full width input utility class */\n.input-full-width {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n/* Full width container utility class */\n.container-full-width {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n/* Force flex items to expand */\n.flex-expand {\n  flex: 1 !important;\n  min-width: 0 !important;\n  width: 100% !important;\n}\n\n/* ===== BREAKOUT UTILITY CLASSES ===== */\n/* Force elements to break out of container constraints */\n.breakout-width {\n  width: 100vw !important;\n  max-width: 100vw !important;\n  margin-left: calc(-50vw + 50%) !important;\n  margin-right: calc(-50vw + 50%) !important;\n  box-sizing: border-box !important;\n}\n\n/* Force full width within parent container */\n.full-width-parent {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n/* ===== SPECIFIC COMPONENT OVERRIDES ===== */\n/* Override any card or container padding that might limit input width */\n.card .nextui-input-wrapper,\n.card .nextui-textarea-wrapper,\n.card .nextui-select-wrapper,\n.card input,\n.card select,\n.card textarea {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n/* Override modal or popup container constraints */\n.modal .nextui-input-wrapper,\n.modal .nextui-textarea-wrapper,\n.modal .nextui-select-wrapper,\n.popup .nextui-input-wrapper,\n.popup .nextui-textarea-wrapper,\n.popup .nextui-select-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n/* Override any grid or flex container constraints */\n.grid .nextui-input-wrapper,\n.grid .nextui-textarea-wrapper,\n.grid .nextui-select-wrapper,\n.flex .nextui-input-wrapper,\n.flex .nextui-textarea-wrapper,\n.flex .nextui-select-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n/* ===== RESPONSIVE WIDTH ENFORCEMENT ===== */\n/* Ensure full width on all screen sizes */\n@media (max-width: 768px) {\n  .nextui-input-wrapper,\n  .nextui-textarea-wrapper,\n  .nextui-select-wrapper,\n  input,\n  select,\n  textarea {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .nextui-input-wrapper,\n  .nextui-textarea-wrapper,\n  .nextui-select-wrapper,\n  input,\n  select,\n  textarea {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\n/* Force consistent form element heights */\ninput,\nselect,\ntextarea,\n.input-field,\n.nextui-select-trigger,\n.nextui-select-wrapper,\n.nextui-input-wrapper,\n.nextui-input,\n.nextui-textarea {\n  height: auto !important;\n  min-height: 44px !important;\n  max-height: none !important;\n}\n\n/* ===== COMPLETE NEXTUI OVERRIDE ===== */\n/* Force NextUI components to match our design exactly */\n.nextui-select-trigger,\n.nextui-select-wrapper,\n.nextui-input-wrapper,\n.nextui-input,\n.nextui-textarea {\n  all: unset !important;\n  width: 100% !important;\n  padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem) !important;\n  font-size: var(--font-size-sm, 0.875rem) !important;\n  border: 2px solid var(--color-neutral-300, #d4d4d4) !important;\n  border-radius: var(--radius-lg, 0.75rem) !important;\n  background-color: white !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  line-height: 1.5 !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n  position: relative !important;\n  outline: none !important;\n  min-height: 44px !important;\n  display: flex !important;\n  align-items: center !important;\n  color: var(--color-neutral-800, #262626) !important;\n  font-family: inherit !important;\n  font-weight: var(--font-weight-normal, 400) !important;\n  letter-spacing: 0.025em !important;\n  box-sizing: border-box !important;\n}\n\n/* NextUI hover states */\n.nextui-select-trigger:hover,\n.nextui-select-wrapper:hover,\n.nextui-input-wrapper:hover,\n.nextui-input:hover,\n.nextui-textarea:hover {\n  border-color: var(--color-primary-400, #34d399) !important;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1) !important;\n  transform: translateY(-1px) !important;\n}\n\n/* NextUI focus states */\n.nextui-select-trigger:focus,\n.nextui-select-wrapper:focus,\n.nextui-input-wrapper:focus,\n.nextui-input:focus,\n.nextui-textarea:focus {\n  outline: none !important;\n  border-color: var(--color-primary-500, #10b981) !important;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15), 0 4px 6px rgba(16, 185, 129, 0.1) !important;\n  transform: translateY(-1px) !important;\n}\n\n/* NextUI error states */\n.nextui-select-trigger.error,\n.nextui-select-wrapper.error,\n.nextui-input-wrapper.error,\n.nextui-input.error,\n.nextui-textarea.error {\n  border-color: var(--color-error, #ef4444) !important;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15), 0 2px 4px rgba(239, 68, 68, 0.1) !important;\n}\n\n/* NextUI success states */\n.nextui-select-trigger.success,\n.nextui-select-wrapper.success,\n.nextui-input-wrapper.success,\n.nextui-input.success,\n.nextui-textarea.success {\n  border-color: var(--color-success, #10b981) !important;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;\n}\n\n/* NextUI disabled states */\n.nextui-select-trigger:disabled,\n.nextui-select-wrapper:disabled,\n.nextui-input-wrapper:disabled,\n.nextui-input:disabled,\n.nextui-textarea:disabled {\n  background-color: var(--color-neutral-100, #f5f5f5) !important;\n  color: var(--color-neutral-500, #737373) !important;\n  cursor: not-allowed !important;\n  border-color: var(--color-neutral-200, #e5e5e5) !important;\n  box-shadow: none !important;\n  transform: none !important;\n}\n\n/* Override NextUI internal elements */\n.nextui-select-trigger .nextui-select-value,\n.nextui-select-trigger .nextui-select-arrow,\n.nextui-input-wrapper .nextui-input,\n.nextui-textarea-wrapper .nextui-textarea {\n  all: unset !important;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  color: inherit !important;\n  font-size: inherit !important;\n  font-weight: inherit !important;\n  font-family: inherit !important;\n}\n\n/* Ensure NextUI labels match our styling */\n.nextui-input-wrapper .nextui-input-label,\n.nextui-textarea-wrapper .nextui-textarea-label,\n.nextui-select-wrapper .nextui-select-label {\n  all: unset !important;\n  display: block !important;\n  font-size: var(--font-size-sm, 0.875rem) !important;\n  font-weight: var(--font-weight-medium, 500) !important;\n  color: var(--color-neutral-700, #404040) !important;\n  margin-bottom: var(--spacing-xs, 0.25rem) !important;\n  line-height: 1.4 !important;\n  transition: color 0.2s ease !important;\n}\n\n/* NextUI label focus states */\n.nextui-input-wrapper:focus-within .nextui-input-label,\n.nextui-textarea-wrapper:focus-within .nextui-textarea-label,\n.nextui-select-wrapper:focus-within .nextui-select-label {\n  color: var(--color-primary-600, #059669) !important;\n}\n\n/* Override any remaining NextUI specific styles */\n[data-slot=\"input\"],\n[data-slot=\"select\"],\n[data-slot=\"textarea\"],\n[data-slot=\"dropdown\"] {\n  all: unset !important;\n}\n\n/* Ensure consistent appearance across all browsers */\n* {\n  box-sizing: border-box;\n}\n\n/* ===== SIMPLE HORIZONTAL FORM LAYOUT ===== */\n/* Easy-to-use class for Cost and Cost Unit layout */\n.cost-form-row {\n  display: flex;\n  gap: var(--spacing-lg, 1rem);\n  align-items: flex-start;\n  margin-bottom: var(--spacing-lg, 1rem);\n}\n\n.cost-form-row .cost-field {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.cost-form-row .cost-field label {\n  display: block;\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-medium, 500);\n  color: var(--color-neutral-700, #404040);\n  margin-bottom: var(--spacing-xs, 0.25rem);\n  line-height: 1.4;\n}\n\n.cost-form-row .cost-field input,\n.cost-form-row .cost-field select,\n.cost-form-row .cost-field .nextui-select-trigger,\n.cost-form-row .cost-field .nextui-select-wrapper {\n  width: 100%;\n  padding: var(--spacing-sm, 0.5rem) var(--spacing-md, 0.75rem);\n  font-size: var(--font-size-sm, 0.875rem);\n  border: 2px solid var(--color-neutral-300, #d4d4d4);\n  border-radius: var(--radius-lg, 0.75rem);\n  background-color: white;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  line-height: 1.5;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  min-height: 44px;\n  color: var(--color-neutral-800, #262626);\n}\n\n.cost-form-row .cost-field input:hover,\n.cost-form-row .cost-field select:hover,\n.cost-form-row .cost-field .nextui-select-trigger:hover,\n.cost-form-row .cost-field .nextui-select-wrapper:hover {\n  border-color: var(--color-primary-400, #34d399);\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1);\n  transform: translateY(-1px);\n}\n\n.cost-form-row .cost-field input:focus,\n.cost-form-row .cost-field select:focus,\n.cost-form-row .cost-field .nextui-select-trigger:focus,\n.cost-form-row .cost-field .nextui-select-wrapper:focus {\n  outline: none;\n  border-color: var(--color-primary-500, #10b981);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15), 0 4px 6px rgba(16, 185, 129, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Responsive design for mobile */\n@media (max-width: 768px) {\n  .cost-form-row {\n    flex-direction: column;\n    gap: var(--spacing-md, 0.75rem);\n  }\n  \n  .cost-form-row .cost-field {\n    margin-bottom: var(--spacing-md, 0.75rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
